<template lang="pug">
  main
    NavBarDucter
    ModalInfo(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:close="cerrarModal")
    section.section.is-small(v-show="!isLoading")
      .container
        .columns.has-text-centered.is-tablet
          .column.is-8.is-offset-2.is-12-mobile
            h1.title.is-size-1.is-title DucterTube
          .column.is-2.is-tablet-6.is-offset-3-mobile.is-6-mobile
            router-link.a.button.is-primary.is-size-5(to="/ducterTube/nuevo") 
              | Subir video&nbsp
              i.fas.fa-file-video
        .columns.has-text-centered.is-tablet.is-multiline
          .column.is-3(v-for="v in videos" :key="v.id")
            .card
              .card-image
                video(
                  poster=""
                  controls,
                )
                  source(
                    :src="getRuta(v.ruta)"
                    type="video/webm"
                  )
              .card-content
                .content
                  | ({{ v.id }})  {{ v.nombre }}
                  br
                  | {{ v.centroTrabajo }} / {{ v.puesto }}
                  br
                  a(href='#') {{ v.email }}
    Loader(v-show="isLoading")
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarDucter from '@/components/layout/NavBarDucter.vue'
import ModalInfo from '@/components/shared/ModalInfo.vue'
import videoServices from '@/services/videos'

export default {
  name: 'Ductertube',
  components: { Loader, ModalInfo, NavBarDucter },
  data () {
    return {
      videos: [],
      isLoading: false,
      modalStatus: false,
      contentModal: '',
      titleModal: '',
      modalNavBar: false,
    }
  },
  methods: {
    cerrarModal () {
      this.modalStatus = false
    },

    getVideos() {
      videoServices.get()
        .then(res => {
          this.videos = res
        })
    },

    getRuta (urlBD) {
      return `https://ducter.com.mx/servidores/ductertube/crud${urlBD}`
    }
  },
  created () {
    this.getVideos()
  },
}
</script>

<style lang="css" scoped>
  #logoDucter {
    max-width: 300px;
    height: auto;
  }
  .image {
    display: inline-block;
  }
  #logo {
    margin-bottom: 30px;
  }

  .card:hover {
  transform: translateY(-5px) scale(1.005) translateZ(0);
  box-shadow: 0 24px 36px rgba(0, 0, 0, 0.11), 0 14px 16px rgba(0, 0, 0, 0.11);
}

.card {
  color: #54545c;
}

  @media (min-width:641px) and (orientation: portrait) {
    .column-login {
      width: 30vh;
      margin-left: 20vh;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/DucterTube.vue